import React from "react";

function LogoutIcon2() {
  return (
    <svg
    width={32}
    height={32}
    viewBox="0 0 25 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="navIcon"
  >
    <path
      d="M21.717.85H10.114C8.56.85 7.327 2.266 7.327 3.969v1.484c0 .476.346.892.81.892.462 0 .808-.416.808-.892V3.97c0-.753.54-1.335 1.169-1.335h11.603c.628 0 1.168.582 1.168 1.335V17.03c0 .753-.54 1.335-1.168 1.335H10.114c-.628 0-1.169-.582-1.169-1.335v-1.484c0-.476-.346-.892-.809-.892-.463 0-.81.416-.81.892v1.484c0 1.703 1.235 3.119 2.788 3.119h11.603c1.553 0 2.787-1.416 2.787-3.119V3.97c0-1.703-1.234-3.119-2.787-3.119zM1.545 8.82h0l2.776-2.773s0 0 0 0a.892.892 0 011.26 1.262h0L2.808 10.08s0 0 0 0a.593.593 0 000 .838l.002.002h0l.001.001h0l2.776 2.81-.107.106.107-.106a.892.892 0 11-1.27 1.254l-2.773-2.808s0 0 0 0a2.38 2.38 0 01.002-3.359z"
      fill="#fff"
      stroke="#fff"
      strokeWidth={0.3}
    />
    <path
      d="M5.47 9.608h7.904a.892.892 0 110 1.784H5.47a.892.892 0 110-1.784z"
      fill="#fff"
      stroke="#fff"
      strokeWidth={0.3}
    />
  </svg>
  );
}

export default LogoutIcon2;
